<template>
    <div class="page" :style="{'--styleColor': style.style_color, backgroundImage:'url('+ style.bg_other +')'}">
        <!-- <TipsZonglan ref="child"></TipsZonglan> -->
        <div class="mainBox">
          <div class="avatar"><img src="@/assets/images/learn/avatar.png" alt=""></div>

          <div class="username">{{username}}</div>
          <div class="boxline"></div>
          <div class="userData">
            <div class="total">
              <span class="txt">总学时</span>
              <span class="num">{{scoreAll}}</span>
            </div>
            <div class="line"></div>
            <div class="must">
              <span class="txt">必修学时</span>
              <span class="num">{{scoreMust}}</span>
            </div>
            <div class="line"></div>
            <div class="done">
              <span class="txt">完成学时</span>
              <span class="num">{{scoreComplete}}</span>
            </div>
          </div>
          <div class="boxline"></div>
          <div class="optBox">
            <div class="icoBox" @click="noticeBox">
                 <div class="icon icon1">
                    <i class="iconfont icon-tishi"></i>                    
                 </div>
                 <span>活动规则</span>
            </div>

            <div class="icoBox" @click="editBox">
                 <div class="icon icon2">
                    <i class="iconfont icon-shezhidefuben"></i>                    
                 </div>
                 <span>资料修改</span>
            </div>

            <div class="icoBox" @click="kefuBox">
                 <div class="icon icon3">
                    <i class="iconfont icon-kefu"></i>                    
                 </div>
                 <span>联系客服</span>
            </div>

            <div class="icoBox" @click="uploadBox">
                 <div class="icon icon4">
                    <i class="iconfont icon-yunshangchuan"></i>                    
                 </div>
                 <span>信息上传</span>
            </div>

            <div class="icoBox" @click="zhengshuBox" v-show="actInfo.pass_score>0">
                 <div class="icon icon5">
                    <i class="iconfont icon-jihuashu"></i>                    
                 </div>
                 <span>我的证书</span>
            </div>

            <div class="icoBox" @click="logOut">
                 <div class="icon icon6">
                    <i class="iconfont icon-qidong"></i>                    
                 </div>
                 <span>退出登录</span>
            </div>

          </div>
        </div>

        <van-popup v-model="showZhengshu" class="showBox" closeable close-icon="close">
          <div class="zhengshu">
            <div id="posterMiddle" class="zsBox">
              <div class="zsTxt">{{username}}</div>
              <div class="snumTxt">{{sncode}}</div>
              <img src="@/assets/images/learn/zheng.jpg" class="zsBg"/>
            </div>
            <div class="loadBox" v-show="showLoad">
              <van-loading vertical>加载中...</van-loading>
            </div>
            <div class="downBox">
              <div id="Image" class="imgBox"></div>
              <div class="downTxt"><i class="iconfont icon-cQuery"></i> 长按图片下载</div>
            </div>
          </div>
        </van-popup>

        

        <!-- 活动规则 -->
        <van-popup v-model="showNotice" closeable close-icon="close" position="bottom" round>          
          <div class="noticBox">        
            <h2 class="noticTitle">
              <span class="line"></span>
              <span class="text">活动规则</span>
              <span class="line"></span>
            </h2>
            <div class="noticTxt" v-html="explain">
              <!-- <p>本次培训共13节课，1学时/课，共13学时。听课不得倍速观看，不得拖拽进度条，完整观看课程后方可积累学时。培训重在提升宣传技能，学完即可，不必过度刷时长。</p>
              <p>听课和答题同步开启；答题分练习和正式考试两个阶段，正式考试不限答题次数，取最高分计入最终成绩。</p>
              <p>满分100分，60分合格。</p>
              <p>修满13学时且考试合格者，即可获得“河北省工伤预防宣传员”证书。</p> -->
            </div>
          </div>
        </van-popup>

        <!-- 联系客服 -->
        <van-popup v-model="showKefu" closeable close-icon="close" position="bottom" round>          
          <div class="noticBox">        
            <h2 class="noticTitle">
              <span class="line"></span>
              <span class="text">联系客服</span>
              <span class="line"></span>
            </h2>
            <div class="noticTxt" v-html="kefu">
              <!-- <p>学习听课及答题考试期间，如有疑问，可联系纵览新闻（河北新闻网）工作人员，也可在“2023重点行业工伤预防宣传企业群”内提问留言，我们会第一时间回复解决。</p> -->
            </div> 
          </div>
        </van-popup>

        <!-- 修改信息 -->
        <van-popup v-model="showEdit" closeable close-icon="close" position="bottom" round>          
          <div class="noticBox">        
            <h2 class="noticTitle">
              <span class="line"></span>
              <span class="text">修改资料</span>
              <span class="line"></span>
            </h2>
            <div class="editBox">
              <van-cell-group>
                <van-form @submit="onSubmit">
                  <van-field v-model="personName" name="personName" label="" placeholder="请输入姓名" :rules="[{ required: true, message: '' }]">
                    <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="renwu-ren" size="20"></van-icon>
                  </van-field>
                  <van-field v-model="contact" name="contact" label="" placeholder="请输入联系方式" :rules="[{ required: true, message: '' }]">
                    <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="shiwu-shoujidefuben" size="20"></van-icon>
                  </van-field>
                  <van-field v-model="company" name="company" label="" placeholder="请输入单位" :rules="[{ required: true, message: '' }]">
                    <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="gongsiqiye" size="20"></van-icon>
                  </van-field>

                  <!-- <van-field v-model="idCard" name="idCard" type="tel" label="" placeholder="请输入身份证号" :rules="[{ required: true, message: '' }]">
                    <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="zhengjian" size="20"></van-icon>
                  </van-field> -->

                  <van-field v-if="actInfo.type_linkageid>0" v-model="typeName" name="typeName" is-link readonly placeholder="请选择所属分类" @click="showType = true" :rules="[{ required: true, message: '' }]">
                    <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="caidan" size="20"></van-icon>
                  </van-field>
                  <van-popup v-model="showType" round position="bottom">
                    <van-picker
                      title="请选择"
                      :default-index="IndexType" 
                      show-toolbar
                      :columns="optionsType"
                      value-key="text"
                      @confirm="onConfirm"
                      @cancel="onCancel"
                      @change="onChange"
                    />
                  </van-popup>

                  <van-field v-if="actInfo.area_linkageid>0" v-model="areaName" name="areaName" is-link readonly placeholder="请选择所属地区" @click="showSelect = true" :rules="[{ required: true, message: '' }]">
                    <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="dingwei1" size="20"></van-icon>
                  </van-field>

                  <van-popup v-model="showSelect" round position="bottom">
                    <van-cascader
                      v-model="areaId"
                      title="请选择所属地区"
                      :options="optionsArea"
                      @close="showSelect = false"
                      @finish="onFinish"
                    />
                  </van-popup>

                  <van-field v-model="areaId" name="areaId" type="hidden"  style="display:none;">
                  </van-field>
                  <!-- <van-field v-model="address" name="address" label="" placeholder="请输入详细地址" :rules="[{ required: true, message: '' }]">
                    <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="dingwei1" size="20"></van-icon>
                  </van-field> -->

                  <div class="subBtn">
                    <van-button round block type="info" native-type="submit">保存信息</van-button>
                  </div>

                </van-form>
              </van-cell-group>
            </div> 
          </div>
        </van-popup>
      
        

        <div class="navBox">
          <div class="navTxt" @click="toHome"><i class="iconfont icon-zhuye"></i>首页</div>
          <div class="navTxt" @click="toMyCenter"><i class="iconfont icon-wode1"></i>个人中心</div>
        </div>
    </div>


    
</template>

<script>

import {reqExplain,reqUserInfo,reqRegInfo,reqEdit} from '@/api/index' //动态接口
import {reqArea} from '@/api/index2.js' //静态接口
//纵览顶部提示栏及唤起app
import TipsZonglan from '@/components/TipsZonglan.vue'
import zonglan from '@/utils/cp-zonglan.js'

//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'

import Cookies from 'js-cookie'

//生成证书
import html2canvas from 'html2canvas';
import Canvas2Image from '@/utils/Canvas2Image.js'

export default {
  mixins: [],
  components: {
    TipsZonglan,
  },
  props: {},
  data () {
    return {
      learnid:0,
      token:"",
      accountId:'',
      uniqueId:'',
      actInfo:"",
      nickname:"",
      username:"",
      scoreAll:0,
      scoreMust:0,
      scoreComplete:0,
      getCert:false,
      showNotice:false,
      showKefu:false,
      showEdit:false,
      showZhengshu:false,
      showLoad:true, //证书加载状态
      sncode:'',
      personName:'',//姓名
      contact:'', //联系方式
      idCard:'',
      address:'',
      company:'',
      passCode:'',
      showSelect: false,
      areaName: '',
      areaId: '',
      // 选项列表，children 代表子选项，支持多级嵌套
      // 选项列表，children 代表子选项，支持多级嵌套
      optionsArea: [
        {
          text: '省政府有关部门',
          value: '1',
          children: [
            { 
              text: '河北省发展和改革委员会', 
              value: '3',
              children:[
                { text:'石家庄',value:'8'}
              ]
            },
            { text: '河北省人力资源和社会保障厅', value: '4' },
            { text: '河北省水利厅', value: '5' }
          ],
        },
        {
          text: '江苏省',
          value: '2',
          children: [{ text: '南京市', value: '6' }],
        },
      ],
      showType: false,
      typeName: '',
      typeId: '',
      IndexType:0,
      optionsType: [
        {
          text:'持证社会工作师',
          value:'110',        
        },
        {
          text:'志愿者',
          value:'111',        
        },
        {
          text:'社区工作人员',
          value:'112',        
        }
      ],
      indexList: [],
      filterData:[], // 处理后的 待渲染数据      
      areaList:[],
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      style:{},
      explain:"",
      kefu:"",
    }
  },
  computed: {},
  watch: {},
  created () {
    this.learnid = this.$route.query.learnid;
    this.token = this.$store.state.token;
    this.accountId = this.$store.state.accountId;
    this.uniqueId = this.$store.state.uniqueId;
    this.actInfo = this.$store.state.actInfo;
    this.shareImg = this.$store.state.actInfo.share_img;
    this.shareTitle = this.$store.state.actInfo.share_title;
    this.shareDesc = this.$store.state.actInfo.share_desc;
    this.style = this.$store.state.actInfo.style;
  },
  mounted() {
    this.userInfo()
    wxShare({
      title: this.shareTitle,
      desc: this.shareDesc,
      img: this.shareImg
    })
  },
  methods: {
    onConfirm(val) {
      this.showType = false;
      this.typeName = val.text;
      this.typeId = val.value;
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      Toast('取消');
    },
    setAreaid(row){
      console.log('row',row);
      this.areaId = row.value;
      this.areaName = row.text;
      this.showSelect = false;
    },
    async getTypeData() {
      let result = await reqArea({linkageid:this.actInfo.type_linkageid});
      this.optionsType = result
    },
    async getAreaData() {
      let result = await reqArea({linkageid:this.actInfo.area_linkageid});
      this.optionsArea = result
    },
    async userInfo(){
      let result = await reqUserInfo({learnid:this.learnid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId});
      if(result.flag=='success'){
        console.log(result);     
        this.nickname = result.nickname;
        this.username = result.username;
        this.scoreAll = result.all_score;
        this.scoreMust = result.limit_score;
        this.scoreComplete = result.score;
        this.sncode = result.sncode;
        console.log('limit_score',Number(result.limit_score));
        console.log('score',Number(result.score));
        if(Number(result.limit_score)<=Number(result.score)){
          this.getCert = true;
        }
      } else {
        this.$toast({
          icon: 'warning-o',
          message: result.message
        });
      }
    },
    async regInfo(){
      let result = await reqRegInfo({learnid:this.learnid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId});
      if(result.flag=='success'){
        console.log(result);     
        this.personName = result.data.username;
        this.contact = result.data.contact;
        this.company = result.data.company;
        this.idCard = result.data.idcard;
        this.address = result.data.address;
        this.typeId = result.data.typeId;
        this.typeName = result.data.typeName;
        this.areaId = result.data.areaId;
        this.areaName = result.data.areaName;
      } else {
        this.$toast({
          icon: 'warning-o',
          message: result.message
        });
      }
    },
    async onSubmit(values) { //表单提交
      console.log('submit', values);
      let result = await reqEdit({...values,learnid:this.learnid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId});
      if(result.flag == 'success'){
        this.$toast({
          icon: 'passed',
          message: result.message
        });
        this.showEdit = false;
      } else {
        this.$toast({
          icon: 'warning-o',
          message: result.message
        });
      }


    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.showSelect = false;
      this.areaName = selectedOptions.map((option) => option.text).join('/');
      if(selectedOptions.length>0){
        this.areaId = selectedOptions[selectedOptions.length-1].value;
      }else{
        this.areaId = selectedOptions[0].value;
      }      
    },
    login(){
      this.$refs.child.toLink()
    },
    logOut(){
      localStorage.clear(); //清空本地观看记录
      Cookies.set('ckplayer-player-cookie','');
      this.$router.push({ path: '/index',query:this.$route.query })  //返回首页
    },
    editBox(){
      this.showEdit = true;
      this.regInfo();
      if(this.actInfo.type_linkageid>0) {
        this.getTypeData();
      } 
      if(this.actInfo.area_linkageid>0) {
        this.getAreaData();
      }   
      
    },
    async noticeBox(){
      let result = await reqExplain({learnid:this.learnid});
      if(result.flag=='success') {
        this.explain = result.data.explain;
      }
      this.showNotice = true;
    },
    async kefuBox(){
      let result = await reqExplain({learnid:this.learnid});
      if(result.flag=='success') {
        this.kefu = result.data.kefu; 
      }
      this.showKefu = true;
    },
    zhengshuBox(){
      // this.$toast({
      //     icon: 'warning-o',
      //     message: "暂无证书"
      // });
      if(this.getCert){
          this.showZhengshu = true;
          let _this = this;
          setTimeout(function(){
            _this.toImage();
          },500)  
      } else {
        this.$toast({
          icon: 'warning-o',
          message: "尚未获得证书"
        });
      }
          
    },    
    toImage(){
		  let domObj = document.getElementById("posterMiddle");
		  //获取到DOM节点的位置
          let width = domObj.offsetWidth;
          let height = domObj.offsetHeight;
          //DOM元素的宽高
          let canvas = document.createElement("canvas")
          //创建canvas
          let scale = 5
          //放大比例设置5倍
          canvas.width = width * scale
          canvas.height = height * scale
          //画板的宽高
          let options = {
              logging: true,
              //日志开关，在控制台可以查看html2canvas的内部执行流程
              width: width,
              height: height,
              //避免下载不全
              useCORS: true,
              //【重要】开启跨域配置
              scale: scale, 
              canvas: canvas,
              //自定义属性
          }
          html2canvas(domObj, options).then((canvas) => {
              let context = canvas.getContext('2d') 
              //关闭锯齿
              context.mozImageSmoothingEnabled = false
              context.webkitImageSmoothingEnabled = false
              context.msImageSmoothingEnabled = false
              context.imageSmoothingEnabled = false
              let img = Canvas2Image.convertToJPEG(canvas, canvas.width, canvas.height)
              // 这就是把canvas转化为图片
              document.getElementById('Image').innerHTML = "";
              document.getElementById('Image').appendChild(img);
              //展示图片的DOM节点
              img.style.width = canvas.width/5 + 'px';
              img.style.height = canvas.height/5 + 'px';
          })          
          this.showLoad = false;
		},
    toHome(){
      this.$router.push({ path: '/list',query:this.$route.query })
    },
    toMyCenter(){
      this.$router.push({ path: '/mycenter',query:this.$route.query })
    },
    uploadBox(){
      window.location.href="https://huodong.wes2.com/hudong/index.php?app_control=1101&mod=entry&con=index&act=view&entryid=212&from=hbrb";
    }
  },
}
</script>
<style lang="scss" scoped>
.page{
  width: 750px;
  min-height: 1366px;
  font-size: 30px;
  background-repeat: no-repeat;
  background-size: contain;
  .mainBox{
    width: 700px;
    min-height:1200px;    
    position: absolute;
    left: 25px;
    top: 200px;    
    background: #fff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding-top: 80px;
    .avatar{
      width: 100%;
      height: 140px;
      display: flex;
      justify-content: center;
      img{
        width: 140px;
        height: 140px;
      }
    }
    .username{
      width: 100%;
      height: auto;
      line-height:50px;
      margin-top: 30px;
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .boxline{ width: 74%; height: 2px; background: #dcdcdc; margin: 0 auto;}
    .userData{
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 15px;
      margin-bottom: 15px;
      .total,.must,.done{
        padding: 0px 40px;  
        color:#919191;
        .txt{
          display: block;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          padding:10px 0px;
        }
        .num{
          display: block;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 40px;
          font-weight: bold;
          padding:10px 0px;
        }
      }
      .total{
        .num{ color:#b5b5b5;}
      }
      .must{
        .num{ color:#f9695d;}
      }

      .done{
        .num{ color:#81a3e5;}
      }
      .line{
        width: 2px;
        height: 100px;
        background: #dcdcdc;
      }

    }

    .optBox{
      width: 620px;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      margin-top: 30px;
      padding: 10px 40px;
      .icoBox{
        width: 205px;
        height: auto;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        text-align: center;
        .icon{
          width: 95px;
          height: 95px;
          border-radius: 25px;
          background: #fbf4da;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 25px;
          i{
            font-size: 50px;
            color: #fff;
          }          
        }
        .icon1{ 
          background: #8CD34B;
        }
        .icon2{ 
          background: #436ECD;
        }
        .icon3{ 
          background: #81D694;
        }
        .icon4{ 
          background: rgb(47, 153, 246);
        }
        .icon5{ 
          background: #FA9B31;
        }
        .icon6{ 
          background: red;
        }
        span{
          display: block;
          width: 100%;
          font-size: 26px;
          line-height: 30px;
          color: #828282;
        }
      }
    }    
  }
  .showBox{
    background: none;
  }

  .zhengshu{
    width: 650px;
    height: 980px;
    margin: 0px 50px;
    margin-top:100px;
    position: relative;
    .zsBox{
      width: 100%;
      height: auto;
      position: absolute;
      left: -100vw;
      top:0;
      z-index: 9;
      .zsBg{
        width: 100%;
        height: auto;
      }
      .zsTxt{ 
        position: absolute;
        left: 110px;
        top: 152px;
        color: #000;
        font-size: 24px;
        font-family: "宋体";
        z-index: 99;
      }
      .snumTxt{ 
        position: absolute;
        right: 90px;
        top: 160px;
        color: #000;
        font-size: 16px;
        font-family: "宋体";
        font-weight: normal;
        z-index: 99;
      }
    }
    .loadBox{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      left: 0;
      top: 0;
      z-index: 100;
    }
    .downBox{
      width: 100%;
      height: auto;
      position: relative;
      left: 0;
      top: 0;
      z-index: 99;
      .imgBox{
        width: 100%;
        height: auto;
      }
      .downTxt{
        width: 100%;
        height: 30px;
        line-height: 30px;
        margin-top:30px;
        font-size: 30px;
        color:#fff;
        text-align: center;
        i{
          font-size: 30px;
        }
      }
    }
    
  }

  .noticBox{ width: 100%; height: auto; font-size: 30px; padding-bottom: 80px; overflow: hidden;}
  .noticTitle{ display: block; width: 100%; height: 30px; margin-top: 80px; font-size: 34px; display: flex; align-items: center; justify-content: center;}
  .noticTxt{ width: 670; height: auto;  padding:0px 40px; margin-bottom: 30px; overflow: hidden; overflow-y: auto;}
  .noticTxt p{ padding: 0; margin: 15px 0px; width: 100%; text-indent: 2em; text-align: justify;}
  .noticBox .text{ padding: 0px 30px; color:var(--styleColor);}
  .noticBox .line{ border-top: 1px solid var(--styleColor); width: 130px; }
  
  .editBox{ 
    width: 670; 
    height: auto;  
    padding:0px 40px; 
    margin-bottom: 30px; 
    overflow: hidden; 
    overflow-y: auto;
    .van-popup{ z-index: 9999;}
    .subBtn{ margin:0px; margin-top:50px;}
    .van-button{ background: var(--styleColor); border: 0px; border-radius: 15px;}
    .iconfont{ padding-right: 15px; margin-right:20px; border-right: 2px solid #e7e8e8;}
    .van-cell{ border:2px solid #e7e8e8; padding:12px 15px; margin-bottom: 30px; border-radius: 10px;}
    .van-cell::after{ border:0px;}
  }
  .areaBox{
    .van-cell{ border:0px; margin:0px 15px; margin-bottom: 10px; border-radius: 0px;}
    .van-index-anchor{ font-weight: bold;}
    ::v-deep .van-index-bar__index{
      padding: 10px 20px;
      font-size: 26px;
    }
  }
  

  .navBox{
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 750px;
    height: 100px;
    background: #f9f9f9;
    border-top: 1px solid #c8c8c8;
    display: flex;
    justify-content: space-evenly;
    font-size: 30px;
    .navTxt{
      padding:0px 50px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #808080;
      font-weight: 400;
      i{
        font-size: 40px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        // color:#808080
      }
    }
  }

}
</style>
